import { Factory } from '../../services/Factory';
import { ProjectService } from '../../services/project/ProjectService';
import { TrackService } from '../../services/auditing/TrackService';
import { UsageType } from '../../model/project/UsageType';
import { ConfigService } from '../../services/config/ConfigService';
import { IProject } from '../../model/project/IProject';
import angular from "angular";

interface CreditCardModalControllerScope extends angular.IScope {
  project: IProject;
  stripe: Stripe.Stripe;
  elements: Stripe.StripeElements;
  addressElement: Stripe.StripeAddressElement;
  cardElement: Stripe.StripeCardElement;
}

export class CreditCardModalController {
  constructor(scope: CreditCardModalControllerScope, project: IProject, uibModalInstance: angular.ui.bootstrap.IModalInstanceService, projectService: ProjectService, notificationService, trackService: TrackService, configService) {
    scope.project = { ...project };
    scope.project.usageType = _.find(Object.keys(UsageType), k =>  k.toLowerCase() == scope.project.usageType) !== undefined ? [{id: scope.project.usageType, name: _.find(Object.keys(UsageType), k =>  k.toLowerCase() == scope.project.usageType)}] : null;
    scope.creditCardInputReady = false;
    scope.creditCardBillingInputReady = false;

    scope.close = () => {
      if (!scope.saving) {
        scope.addressElement.unmount();
        scope.addressElement.destroy();

        uibModalInstance.close();
      }
    };

    scope.forms = {};
    scope.newProject = {};
    scope.saving = false;
    scope.UsageTypes = [{id: UsageType.Processing, name: Object.keys(UsageType)[0]}, {
      id: UsageType.ECA,
      name: Object.keys(UsageType)[1]
    }, {id: UsageType.Review, name: Object.keys(UsageType)[2]}];

    // After custom validation, we clear it out with this method
    scope.setValid = elm => {
      _.each(elm.$error, (value, key, list) => {
        if (value && key !== "required") {
          elm.$setValidity(key, true);
        }
      });
    };

    uibModalInstance.rendered.then(() => {
      scope.stripe = (<any>Stripe)(configService.getStripePubKey());
      const options: Stripe.StripeAddressElementOptions = {mode: "billing"};
      const cardOptions: Stripe.StripeCardElementOptions = {
        disableLink: true,
        hidePostalCode: true,
        classes: {base: "stripe-card"}
      };
      const appearance: Stripe.Appearance = {
        labels: "floating",
        variables: {
          colorPrimary: '#0570de',
          colorTextPlaceholder: "#555555",
          gridRowSpacing: "4px",
          borderRadius: "4px",
          fontSizeBase: "14px"
        }
      };
      scope.elements = scope.stripe.elements({mode: "setup", currency: "usd", appearance});
      scope.addressElement = scope.elements.create("address", options);
      scope.cardElement = scope.elements.create("card", cardOptions);
      scope.addressElement.mount("#address-element");
      scope.cardElement.mount("#card-element");

      scope.addressElement.on("change", (e: Stripe.StripeAddressElementChangeEvent) => {
        scope.creditCardBillingInputReady = e.complete;

        scope.$applyAsync();
      });

      scope.cardElement.on("change", (e: Stripe.StripeCardElementChangeEvent) => {
        scope.creditCardInputReady = e.complete;

        scope.$applyAsync();
      });
    });

    scope.saveCreditCard = async () => {
      scope.saving = true;
      const address = await scope.addressElement.getValue();

      if (!address.complete) {
        scope.saving = false;
        scope.$applyAsync();

        return;
      }

      scope.project.usageType = scope.project.usageType[0]?.id;

      scope.stripe.createToken(scope.cardElement, {
        name: address.value.name,
        address_line1: address.value.address.line1,
        address_line2: address.value.address.line2 ?? "",
        address_city: address.value.address.city,
        address_state: address.value.address.state,
        address_zip: address.value.address.postal_code,
        address_country: address.value.address.country
      }).then(response => {
        if (response.error) {
          // re-enable the submit button
          scope.saving = false;
        } else {
          scope.project.token = response.token.id;

          projectService.UpdateProject(scope.project).then((_project) => {
            scope.saving = false;
            scope.close();
            scope.project.status = _project.status;
            project.status = scope.project.status;

            notificationService.addSuccess({
              title: 'Credit Card Updated',
              description: 'Thank you for being awesome.',
              timeout: 5000
            });

            trackService.TrackCreditCardEnteredConversion();
            scope.$apply();

          }).catch(() => {
            scope.saving = false;
          });
        }

        project.usageType = _.find(Object.values(UsageType), k =>  k.toLowerCase() == scope.project.usageType);
        scope.project.usageType = _.find(Object.keys(UsageType), k =>  k.toLowerCase() == scope.project.usageType) !== undefined ? [{id: scope.project.usageType, name: _.find(Object.keys(UsageType), k =>  k.toLowerCase() == scope.project.usageType)}] : null;
      });
    }
  }
}

frontendApp.controller("CreditCardModalController", ["$scope", "project", "$uibModalInstance", "ProjectService", "NotificationService", "TrackService", "ConfigService", Factory.Create(CreditCardModalController)]);
